module.exports = "https://static.im-cdn.com/mjc/storefront/Esteem/static/media/FooterLinkedin.7f6372ab.svg";